<template>
  <div
    v-click-outside="closeFilter"
    class="row"
    :class="isMobile && 'flex-column-reverse'"
  >
    <div
      class="pt-2 px-0"
      :class="{ 'col-md-8': filterApplied, 'col-md-10': !filterApplied }"
    >
      <div
        v-if="filterApplied"
        class="d-flex"
        :class="isMobile && 'scroll-h mt-4'"
      >
        <div
          v-if="value.provider"
          class="border px-3 mr-2 filter-selection-tag"
        >
          <div
            class="d-flex justify-content-center align-items-center my-1 mx-3"
          >
            <i class="fas fa-user-tie text-orange mr-2" />
            <p class="m-0">{{ value.provider.name }}</p>
          </div>
        </div>
        <div
          v-if="value.municipality"
          class="border px-3 mr-2 filter-selection-tag"
        >
          <div
            class="d-flex justify-content-center align-items-center my-1 mx-3"
          >
            <i class="fas fa-map-marker-alt text-orange mr-2" />
            <p class="m-0">{{ value.municipality.name }}</p>
          </div>
        </div>
        <div
          v-if="value.locationService"
          class="border px-3 mr-2 filter-selection-tag"
        >
          <div
            class="d-flex justify-content-center align-items-center my-1 mx-3"
          >
            <i class="fas fa-school text-orange mr-2" />
            <p class="m-0">{{ value.locationService.name }}</p>
          </div>
        </div>
        <div
          v-if="value.disciplineType"
          class="border px-3 mr-2 filter-selection-tag"
        >
          <div
            class="d-flex justify-content-center align-items-center my-1 mx-3"
          >
            <i class="fas fa-file-alt text-orange mr-2" />
            <p class="m-0">{{ value.disciplineType.name }}</p>
          </div>
        </div>
      </div>
    </div>
    <div
      class="px-0"
      :class="{ 'col-md-4': filterApplied, 'col-md-2': !filterApplied }"
    >
      <div class="d-flex flex-row-reverse availability-calendar-filter">
        <dropdown
          v-if="!editMode"
          always-show-dropdown
          class="actions-dropdown mx-1"
          :items="actionItems"
          title="Acciones"
        />
        <action-button
          id="calendar-filter-btn"
          :class="isMobile && 'w-100'"
          :disabled="editMode"
          :iright="iRightFilter"
          variant="success px-3 ml-1"
          @click="onToggleFilter"
        >
          <img class="mr-2" :src="barsFilterIcon" />
          Filtrar
        </action-button>
        <action-button
          v-if="filterApplied"
          id="calendar-add-journey-btn"
          :disabled="editMode"
          i="fa fa-calendar-plus fa-lg"
          variant="outline-success px-3 ml-1"
          @click="onAddJourney"
        >
          Añadir Jornada
        </action-button>
        <custom-toggle
          v-if="filterApplied"
          :options="periods"
          @input="onPeriodChange"
        />
        <AddAvailableSpace
          v-if="isAddAvailableSpaceOpen"
          id="miModal"
          :is-mobile="isMobile"
          :model-edit="modelAddAvailableSpace"
          @close="() => onToggleAddAvailableSpaceOpen(false)"
          @save="saveAvailableSpace"
        />
        <div
          v-if="isFilterOpen"
          class="modal-dialog"
          :class="isMobile && 'modal-mobile'"
        >
          <validation-observer ref="formRef" novalidate>
            <div class="modal-content border-0">
              <div class="modal-header px-4">
                <h5 class="modal-title">
                  <div class="d-inline mr-2">
                    <img :src="barsFilterIcon" />
                  </div>
                  Filtrar Búsqueda
                </h5>
              </div>
              <div class="modal-body px-4">
                <div class="px-2">
                  <div class="mt-1">
                    <validation-provider v-slot="{ errors }" rules="required">
                      <custom-drop-down
                        id="calendar-provider-cdd"
                        v-model="value.provider"
                        :custom-error-msg="errorMsgs.provider"
                        :disabled="options.providers.length == 1"
                        :error="errors[0]"
                        fieldkey="id"
                        fieldname="name"
                        label="Proveedor:"
                        :options="options.providers"
                        placeholder="Seleccione"
                        @input="onProviderChange"
                      >
                        <template v-slot:option="{ name }">
                          <span class="text-wrap">
                            {{ name }}
                          </span>
                        </template>
                      </custom-drop-down>
                    </validation-provider>
                  </div>
                  <div class="mt-3">
                    <validation-provider v-slot="{ errors }" rules="required">
                      <custom-drop-down
                        id="calendar-municipality-cdd"
                        v-model="value.municipality"
                        :custom-error-msg="errorMsgs.municipality"
                        :disabled="options.municipalities.length == 1"
                        :error="errors[0]"
                        fieldkey="id"
                        fieldname="name"
                        label="Municipio:"
                        :options="options.municipalities"
                        placeholder="Seleccione"
                        @input="onMunicipalityChange"
                      >
                        <template v-slot:option="{ name }">
                          <span class="text-wrap">
                            {{ name }}
                          </span>
                        </template>
                      </custom-drop-down>
                    </validation-provider>
                  </div>
                  <div class="mt-3">
                    <validation-provider v-slot="{ errors }" rules="required">
                      <custom-drop-down
                        id="calendar-location-service-cdd"
                        v-model="value.locationService"
                        :custom-error-msg="errorMsgs.locationService"
                        :disabled="options.locationServices.length == 1"
                        :error="errors[0]"
                        fieldkey="id"
                        fieldname="name"
                        label="Lugar de Servicio:"
                        :options="options.locationServices"
                        placeholder="Seleccione"
                        @input="onLocationServiceChange"
                      >
                        <template v-slot:option="{ name }">
                          <span class="text-wrap">
                            {{ name }}
                          </span>
                        </template>
                      </custom-drop-down>
                    </validation-provider>
                  </div>
                  <div class="mt-3">
                    <validation-provider v-slot="{ errors }" rules="required">
                      <custom-drop-down
                        id="calendar-discipline-cdd"
                        v-model="value.disciplineType"
                        :custom-error-msg="errorMsgs.disciplineType"
                        :disabled="options.disciplines.length == 1"
                        :error="errors[0]"
                        fieldkey="id"
                        fieldname="name"
                        label="Disciplina:"
                        :options="options.disciplines"
                        placeholder="Seleccione"
                      >
                        <template v-slot:option="{ name }">
                          <span class="text-wrap">
                            {{ name }}
                          </span>
                        </template>
                      </custom-drop-down>
                    </validation-provider>
                  </div>
                  <div class="my-4">
                    <action-button
                      id="calendar-filter-apply-btn"
                      variant="success px-3 w-100"
                      @click="onFilter"
                    >
                      <img class="mr-2" :src="barsFilterIcon" />
                      Filtrar
                    </action-button>
                  </div>
                </div>
              </div>
            </div>
          </validation-observer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import CustomDropDown from '@/components/common/form/CustomDropDown.vue';
import AddAvailableSpace from './AddAvailableSpace.vue';
import CustomToggle from '@quisit/mipe-custom-toggle';
import Dropdown from 'dropdown';

export default {
  name: 'AvailabilityCalendarFilter',
  components: {
    ActionButton,
    CustomDropDown,
    AddAvailableSpace,
    CustomToggle,
    Dropdown,
  },
  directives: {
    'click-outside': {
      bind: function(el, binding) {
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener('click', handler);
      },

      unbind: function(el) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      },
    },
  },
  props: {
    value: {
      type: Object,
      default: function() {
        return {
          provider: null,
          municipality: null,
          locationService: null,
          disciplineType: null,
        };
      },
    },
    options: {
      type: Object,
      default: () => [
        {
          providers: [],
          municipalities: [],
          locationServices: [],
          disciplines: [],
        },
      ],
    },
    isAddAvailableSpaceOpen: {
      type: Boolean,
      default: false,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
    modelAddAvailableSpace: {
      type: Array,
      default: () => [],
    },
    editMode: {
      type: Boolean,
      default: false,
    },
    isAdmissionCoordination: {
      type: Boolean,
      default: false,
    },
    isCoordination: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isFilterOpen: false,
    errorMsgs: {
      provider: 'El proveedor es requerido.',
      municipality: 'El municipio es requerido.',
      locationService: 'El lugar de servicio es requerido.',
      disciplineType: 'La disciplina es requerida.',
    },
    filterApplied: false,
    hasAdmission: false,
    periods: [
      { text: 'AM', value: 1, checked: true },
      {
        text: 'PM',
        value: 2,
      },
    ],
  }),
  computed: {
    iLeftClean() {
      return require('@/assets/img/filter-circle-xmark.svg');
    },
    barsFilterIcon() {
      return require('@/assets/img/bars-filter.svg');
    },
    iRightFilter() {
      const value = 'fa fa-xs';
      return this.isFilterOpen
        ? `${value} fa-chevron-up`
        : `${value} fa-chevron-down`;
    },
    actionItems() {
      return [
        {
          label: 'Limpiar',
          icon: `fas fa-filter text-green`,
          visible: true,
          click: () => {
            this.onCleanUp();
          },
        },
        {
          label: 'Eliminar',
          icon: 'fas fa-times-circle text-danger',
          visible:
            this.userHasPermissions(
              'provider.calendar.specialist.availability.remove.serviceplace'
            ) ||
            this.userHasPermissions(
              'provider.calendar.specialist.availability.remove.serviceplace.byspecialist'
            ),
          click: () => {
            this.$emit('apply-action');
          },
        },
      ];
    },
  },
  watch: {
    isFilterOpen: function(val) {
      if (val) {
        this.onToggleAddAvailableSpaceOpen(false);
      }
    },
    isAddAvailableSpaceOpen: function(val) {
      if (val) {
        this.isFilterOpen = false;
      }
    },
  },
  mounted() {
    this.openFilterByDefault();
    if (
      this.value.provider ||
      this.value.municipality ||
      this.value.locationService ||
      this.value.disciplineType
    ) {
      this.filterApplied = true;
    }
  },
  methods: {
    onPeriodChange(value) {
      this.$emit('period-changed', value);
    },
    onToggleFilter() {
      this.isFilterOpen = !this.isFilterOpen;
      this.$emit('toggle-filter', this.isFilterOpen);
    },
    onAddJourney() {
      this.onToggleAddAvailableSpaceOpen(true);
      this.$emit('add-journey');
    },
    onProviderChange(item) {
      this.$emit('change-provider', item);
    },
    onMunicipalityChange(item) {
      this.$emit('change-municipality', item);
    },
    onLocationServiceChange(item) {
      this.$emit('change-location-service', item);
    },
    async onFilter() {
      const isValid = await this.$refs.formRef.validate();
      if (!isValid) return;

      this.$emit('input', { ...this.value });
      this.isFilterOpen = false;
      this.filterApplied = true;
    },
    onCleanUp() {
      this.filterApplied = false;
      this.onToggleAddAvailableSpaceOpen(false);
      this.$emit('clean-up');
    },
    closeFilter() {
      this.isFilterOpen = false;
    },
    openFilterByDefault() {
      this.hasAdmission = Boolean(this.$route.params.admissionId);
      if (this.hasAdmission) {
        this.filterApplied = true;
      }
      setTimeout(() => {
        this.isFilterOpen = !this.hasAdmission;
      }, 100);
    },
    onToggleAddAvailableSpaceOpen(value) {
      this.$emit('toggle-add-available-space-open', value);
    },
    saveAvailableSpace(e) {
      this.isAddAvailableSpaceOpen = false;
      this.$emit('save', e);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/shared/scss/config/_colors.scss';
.availability-calendar-filter {
  position: relative;
}

@media (min-width: 768px) {
  .availability-calendar-filter > .modal-dialog {
    position: absolute;
    z-index: 1050;
    top: 2rem;
    min-width: 27.5rem;
  }
}
.availability-calendar-filter .modal-header {
  box-shadow: 0px 3px 6px #00000029;
}
.availability-calendar-filter .modal-content {
  box-shadow: 0px 2px 8px rgb(0 0 0 / 35%);
}

.availability-calendar-filter .modal-title > div {
  padding: 5px 10px;
  border: 3px solid white;
  border-radius: 30px;
  box-shadow: 0px 3px 6px #00000029;
  background: map-get($colors, 'orange');
}

.filter-selection-tag {
  border-radius: 30px;
  font-weight: 700;
}
.filter-selection-tag > i {
  font-size: 18px;
}

.modal-mobile {
  position: absolute;
  z-index: 1;
  min-width: 97vw !important;
  top: 3rem !important;
  left: 55% !important;
  transform: translateX(-57%);
}

.scroll {
  width: 100%;
  overflow-x: scroll;
  white-space: nowrap;
  scrollbar-width: none;
  -ms-overflow-style: none;
  box-sizing: border-box;
  height: 3rem;
  & > div {
    min-width: 100px;
  }
}
.scroll::-webkit-scrollbar {
  display: none;
}

//media query for mobile
@media (max-width: 767px) {
  button {
    white-space: nowrap;
  }
  .modal-title > h5 {
    font-weight: bold;
    font-size: 16px;
  }
}

.scroll-h {
  width: 100%;
  overflow-x: scroll;
  white-space: nowrap;
  scrollbar-width: none;
  -ms-overflow-style: none;
  box-sizing: border-box;
}
.scroll-h::-webkit-scrollbar {
  display: none;
}

button[disabled].ab-btn.ab-btn-outline-success {
  color: #959595 !important;
  font-weight: 700 !important;
  border-color: #959595 !important;
}
button[disabled].ab-btn.ab-btn-success,
button[disabled].ab-btn.ab-btn-orange {
  color: #959595 !important;
  font-weight: 700 !important;
  border-color: #959595 !important;
  background: #e2e2e2 !important;
}
button[disabled].ab-btn.ab-btn-success img,
button[disabled].ab-btn.ab-btn-orange img {
  filter: invert(69%) sepia(2%) saturate(16%) hue-rotate(338deg) brightness(86%)
    contrast(84%);
}
</style>
